import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import api from "../../api/api";
import {isSaveForCartResponse, SaveForCartPayload, SaveForCartResponse} from "./useSaveForCart-types";
import {appendUrlGetParameter} from "../../../utils/FormatUtils";

const cartSaveEndpoint = window.wpAjaxUrl || '/wp/wp-admin/admin-ajax.php';

const headers = {"Content-Type": "multipart/form-data"};

export const useSaveForCart = () => {
    return useMutation(
        [cartSaveEndpoint],
        (params: SaveForCartPayload) => {

            const requestUrl = appendUrlGetParameter(cartSaveEndpoint, 'action', params.action);

            const data = {
                action: params.action,
                nonce: params.nonce,
                image: params.image,
                components_id: params.componentsIds.join(','),
            };

            return api.post<SaveForCartResponse>(requestUrl, data, {headers, baseURL: '/'})
                .then((response: unknown) => {

                    if (!response || !isSaveForCartResponse(response)) {
                        throw new AxiosError('Add-To-Cart Request have wrong response', 'WRONG_RESPONSE_CART');
                    }

                    if (response.cart_hash !== 'success') {
                        throw new AxiosError('Add-To-Cart Request wrong cart hash', 'WRONG_RESPONSE_CART_HASH');
                    }

                    return response;
                })
                .catch((err: unknown) => {
                    throw err;
                });
        },
    )
};
